import { DOCUMENT } from '@angular/common';
import { AfterViewInit, Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationExtras, Params, Router } from '@angular/router';
import { IResponseLower, PrebootService, UiHelperService } from 'core-max-lib';
import { Subscription } from 'rxjs';
import { isNullOrUndefined } from 'core-max-lib';
import { MagazineService } from '../../interfaces/magazine-service.interface';
import { IMagazineArticle, IMagazineCategory, IMagazineCategoryArticlesResult, IMagazineLobbyArticle, IMagazineResult } from '../../models/magazine-result';

declare var $: any;

@Component({
    selector: 'lib-magazine',
    templateUrl: './magazine.component.html',
    styleUrls: ['./magazine.component.scss']
})
export class MagazineComponent implements OnInit, OnDestroy, AfterViewInit {
    articles: IMagazineLobbyArticle[] = [];
    requestedCategory: string;
    moreArticles: boolean;
    nextPage = 0;
    catData: IMagazineCategory;
    subs: Subscription[] = [];
    isMobile: boolean;

    // magazine tab slider
    categorySlideConfig = {
        dots: false,
        infinite: false,
        centerMode: false,
        speed: 200,
        swipeSpeed: 200,
        arrows: false,
        rtl: true,
        slidesToShow: 3,
        slidesToScroll: 2,
        mobileFirst: true,
        responsive: [
            {
                breakpoint: 767,
                settings: 'unslick'
            }
        ]
    };

    constructor(
        @Inject(DOCUMENT) private readonly document: any,
        public magazineService: MagazineService,
        private prebootSvc: PrebootService,
        private activatedRoute: ActivatedRoute,
        public router: Router,
        private uiHelper: UiHelperService
    ) { }

    ngOnInit(): void {
        this.isMobile = this.magazineService.isMobile();
        this.magazineService.insertStylesFix();
        this.changeTitleTextColor();
        this.subs.push(this.activatedRoute.params.subscribe((params: Params) => {

            this.requestedCategory = isNullOrUndefined(params['magazine-category']) ? '' : params['magazine-category'];
            if (this.requestedCategory === '') { // all-articles
                this.magazineService.pushToGtm('Lobby', 'Load');
            }
            else if (this.requestedCategory) {
                this.magazineService.pushToGtm('Category – ' + this.requestedCategory, 'Load');
            }

            if (!this.magazineService.magazineDetails) {
                this.getData(true);
            }
            else {
                var catData =
                    this.magazineService.magazineDetails.categories.filter(c => c.urlName === this.requestedCategory)[0];
                if (catData && catData.articles && catData.articles.articles && catData.articles.articles.length > 0) {
                    this.catData = catData;
                    this.loadCategory();
                }
                else {
                    this.nextPage = 0;
                    this.getData(false);
                }
            }
        }));
    }

    getData(firstLoad: boolean, add: boolean = false) {
        this.subs.push(this.magazineService.getLobby(this.nextPage, this.requestedCategory).subscribe((res: IResponseLower<IMagazineResult>) => {
            if (res.returnCode !== 0) {
                this.magazineService.redirectToErrorPage();
                return;
            }

            this.catData = res.result.categories.filter(c => c.isActive)[0];
            if (firstLoad) {
                this.magazineService.magazineDetails = res.result;
            }
            this.loadCategory(add);
        }));
    }

    loadCategory(add: boolean = false): void {

        const index = this.magazineService.magazineDetails.categories.findIndex(c => c.urlName === this.requestedCategory);
        this.magazineService.magazineDetails.categories.forEach(c => {
            c.isActive = false
        });
        if (index >= 0) {
            this.magazineService.magazineDetails.categories[index].isActive = true;

            if (this.magazineService.magazineDetails.categories[index].articles) {
                if (add) {
                    this.magazineService.magazineDetails.categories[index].articles.articles.push(...this.catData.articles.articles);
                    this.magazineService.magazineDetails.categories[index].nextPage++;
                    this.nextPage = this.magazineService.magazineDetails.categories[index].nextPage;
                }
                else {
                    if (isNaN(this.magazineService.magazineDetails.categories[index].nextPage)){
                        this.nextPage = this.magazineService.magazineDetails.categories[index].nextPage = 1;
                    }
                    else {
                        this.nextPage = this.magazineService.magazineDetails.categories[index].nextPage =
                        this.magazineService.magazineDetails.categories[index].nextPage++;
                    }
                }

                this.magazineService.magazineDetails.categories[index].articles.isLast = this.catData.articles.isLast;
            }
            else {
                this.magazineService.magazineDetails.categories[index].articles = <IMagazineCategoryArticlesResult>
                    {
                        isLast: this.catData.articles.isLast,
                        articles: [...this.catData.articles.articles]
                    };
                    this.magazineService.magazineDetails.categories[index].nextPage = 1;
                    this.nextPage = 1;
            }

            this.articles = this.magazineService.magazineDetails.categories[index].articles.articles;
            this.moreArticles = !this.magazineService.magazineDetails.categories[index].articles.isLast;
        }
    }

    showMore(): void {
        if (this.requestedCategory === '') { // all-articles
            this.magazineService.pushToGtm('Lobby', 'More articles');
        }
        else if (this.requestedCategory) {
            this.magazineService.pushToGtm('Category – ' + this.requestedCategory, 'More articles');
        }
        this.getData(false, true);
    }

    ngAfterViewInit() {
        if (this.uiHelper.isBrowser) {
            this.prebootSvc.transitionComplete.subscribe(stable => {
                if (stable) {
                    $('.center').on('init', function (
                        event,
                        slick
                    ) {
                        slick.slickGoTo(0);
                    });
                    $('.center').slick(this.categorySlideConfig);
                }
            });
        }
    }

    ngOnDestroy(): void {
        this.magazineService.removeStylesFix();
        this.subs.forEach(sub => sub.unsubscribe())
    }



    navigateToMagazineArticle(article: IMagazineLobbyArticle, e) {
        e.preventDefault();
        this.magazineService.pushToGtm('Click on article', article.title || '');

        let navExtra: NavigationExtras = { queryParams: { sourceGA: 'Loby' } };
        return article.pageUrl == null ?
            this.router.navigate([article.categoryUrl, 'magazine', article.title], navExtra) :
            this.router.navigate([article.categoryUrl, 'magazine', article.pageUrl], navExtra);
    }

    getMagazineArticleHref(article: IMagazineLobbyArticle) {
        return `/${article.categoryUrl}/magazine/${article.pageUrl == null ? article.title : article.pageUrl}?sourceGA=Loby`;
    }

    navigateToMagazineCategory(categoryUrl: string, categoryName: string) {
        const isCatUrl = !isNullOrUndefined(categoryUrl) && categoryUrl !== '';
        if (isCatUrl)
            this.magazineService.pushToGtm('Click on category', categoryName);

        return this.router.navigate(isCatUrl ? [categoryUrl, 'magazine'] : ['magazine']
        );
    }

    changeTitleTextColor() {
        if (this.document.head.querySelector(`style[id="magazineLobbyTitleTextColor"]`)) {
            return;
        }
        const styleElement = this.document.head.appendChild(this.document.createElement('style')) as HTMLStyleElement;
        styleElement.setAttribute('type', 'text/css');
        styleElement.setAttribute('id', 'magazineLobbyTitleTextColor');
        const titleColor = this.magazineService.getLobbyMagazineTitleTextColor();
        styleElement.innerHTML =
        `.loby-magazine .main-banner h1 {color: ${titleColor};}.loby-magazine .main-banner h2 {color: ${titleColor};}`;
    }
}
